import { useEffect } from 'react';
import { hasAuthParams, useAuth } from 'react-oidc-context';
import { useParams } from 'react-router-dom';

import { AppLoader } from '@ingrid/luterkort-react';

import { CONFIG } from '~src/config/config';
import { AppFetchConfig } from '~src/main/config';

/**
 * Lookup map that turns customer (path) into a forced connection.
 * If no mapping exists, Auth0 Home Realm Discovery is used.
 */
const Connection: Record<string, string | undefined> = {
  apoteket: CONFIG.AUTH0_APOTEKET_CONNECTION,
};

export function AppLoginPage() {
  const { customer } = useParams();
  const auth = useAuth();

  /**
   * @external: https://github.com/authts/react-oidc-context/blob/main/src/withAuthenticationRequired.tsx
   */
  useEffect(() => {
    if (hasAuthParams() || auth.isLoading || auth.activeNavigator || auth.isAuthenticated) {
      return;
    }

    void (async () => {
      const forcedConnection = customer ? Connection[customer] : undefined;

      await auth.signinRedirect({
        extraQueryParams: {
          audience: `${AppFetchConfig.apiUrl}/`,
          ...(forcedConnection ? { connection: forcedConnection } : {}),
        },
      });
    })();
  }, [auth, customer]);

  return <AppLoader />;
}
